// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mainHelp {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
    padding: 77px 16px 100px 16px;
}

.myHelpContent {
    display: flex;
    flex-direction: column;
    width: 100%;
    background: #FFF4D9;
    border-radius: 16px;
    padding: 30px 0 0 0;
    position: relative;
    /*min-height: calc(100vh - 177px);*/
    width: 398px;
    height: 755px;
    gap: 45px;
}

.myHelpContentHeader {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 0 30px;
}

.myHelpContentHeaderTitle {
    font-family: Alegreya Sans;
    font-size: 32px;
    font-weight: 700;
    line-height: 25.6px;
    text-align: left;
    color: rgba(75, 45, 16, 1);
}

.QR {
    display: flex;
    align-items: center;
    gap: 67px;
}

.Names {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
    width: 329px; 
    height: 48px;
    font-size: 20px;
}

.Nams {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
    width: 332px; 
    height: 29px;
    font-size: 24px;
    margin: 0 auto;
}

.myHelpContentHeaderButton {
    width: max-content;
    height: auto;
    padding: 8px 16px;
    border-radius: 16px;
    background: #FF6B00;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    font-family: Alegreya Sans;
    font-size: 14px;
    font-weight: 500;
    line-height: 16.8px;
    text-align: left;
    color: #FFF4D9;
}

.myHelpEmptyColumn {
    display: flex;
    flex-direction: column;
    gap: 80px;
    width: 100%;
    height: calc(100vh - 240px);
    align-items: center;
    justify-content: flex-end;
}

/* .myHelpEmptyImage {
    width: 320.34px;
    height: 300.03px;
    margin: auto;
    margin-top: 43px;
} */

.linkNolineCreate {
    text-decoration: none;
}



`, "",{"version":3,"sources":["webpack://./src/components/Profile/Help/Help.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,uBAAuB;IACvB,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,mCAAmC;IACnC,YAAY;IACZ,aAAa;IACb,SAAS;AACb;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,WAAW;IACX,2BAA2B;IAC3B,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;;;;;GAKG;;AAEH;IACI,qBAAqB;AACzB","sourcesContent":[".mainHelp {\n    display: flex;\n    width: 100%;\n    align-items: center;\n    justify-content: center;\n    padding: 77px 16px 100px 16px;\n}\n\n.myHelpContent {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    background: #FFF4D9;\n    border-radius: 16px;\n    padding: 30px 0 0 0;\n    position: relative;\n    /*min-height: calc(100vh - 177px);*/\n    width: 398px;\n    height: 755px;\n    gap: 45px;\n}\n\n.myHelpContentHeader {\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0 30px;\n}\n\n.myHelpContentHeaderTitle {\n    font-family: Alegreya Sans;\n    font-size: 32px;\n    font-weight: 700;\n    line-height: 25.6px;\n    text-align: left;\n    color: rgba(75, 45, 16, 1);\n}\n\n.QR {\n    display: flex;\n    align-items: center;\n    gap: 67px;\n}\n\n.Names {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-end;\n    width: 329px; \n    height: 48px;\n    font-size: 20px;\n}\n\n.Nams {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-end;\n    width: 332px; \n    height: 29px;\n    font-size: 24px;\n    margin: 0 auto;\n}\n\n.myHelpContentHeaderButton {\n    width: max-content;\n    height: auto;\n    padding: 8px 16px;\n    border-radius: 16px;\n    background: #FF6B00;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: none;\n    font-family: Alegreya Sans;\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 16.8px;\n    text-align: left;\n    color: #FFF4D9;\n}\n\n.myHelpEmptyColumn {\n    display: flex;\n    flex-direction: column;\n    gap: 80px;\n    width: 100%;\n    height: calc(100vh - 240px);\n    align-items: center;\n    justify-content: flex-end;\n}\n\n/* .myHelpEmptyImage {\n    width: 320.34px;\n    height: 300.03px;\n    margin: auto;\n    margin-top: 43px;\n} */\n\n.linkNolineCreate {\n    text-decoration: none;\n}\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
